module.exports = __webpack_public_path__ + "img/my-target.3f8d52e5.svg";